import { useEffect, useState, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { getApiClient } from 'api/call';
import type { PositionedBannerSlotResponse } from 'api/generated';
import { getPositionedBannersBySlot } from 'api/generated/sdk.gen';
import AdSenseBanner from 'ui/design-base/AdSenseBanner';
import TennistalkerBanner from './TennistalkerBanner';

const cachedClient = getApiClient(true);

const Banner = ({ slot, className }: { slot: string; className?: string }) => {
  const location = useLocation();
  const [bannerData, setBannerData] = useState<PositionedBannerSlotResponse | undefined>();
  const mounted = useRef(true);
  useEffect(() => {
    const fetchBanner = async () => {
      try {
        const response = await getPositionedBannersBySlot({ client: cachedClient, path: { slot } });
        if (mounted.current) {
          setBannerData(response.data);
        }
      } catch (error) {
        console.error('Error fetching banner data:', error);
      }
    };
    fetchBanner();
    return () => {
      mounted.current = false;
    };
  }, [slot, location]);

  if (bannerData) {
    const { image_url, destination } = bannerData;
    const bannerClassName = `flex justify-center ${slot}`;
    return (
      <div className={bannerClassName}>
        {image_url === null || destination === null ? (
          <AdSenseBanner slot={'8655737458'} />
        ) : (
          <TennistalkerBanner
            imageUrl={image_url as string}
            destination={destination as string}
            className={className}
          />
        )}
      </div>
    );
  }
  return null;
};

export default Banner;
